import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Fab, Fade, Typography, IconButton } from '@material-ui/core';
import Close from "@material-ui/icons/Close"
import Button from 'components/Button'

const useStyles = makeStyles(theme => ({
    typography: {
        padding: theme.spacing(2),
    },
    paper: {
        position: "absolute",
        bottom: "100%",
        left: "50%",
        transform: "translateX(-50%)", // using any animation other than Fade may overide this
        marginBottom: theme.spacing(1),
        borderRadius: theme.spacing(2),
        minWidth: 300,
        [theme.breakpoints.down('xs')]: {
         minWidth: 250
        },
        maxWidth: "100%"
    },
    container: {
        border: `1px solid ${theme.palette.primary.main}`

    },
    caret: {
        position: "absolute",
        bottom: -(theme.spacing(1) - 2),
        backgroundColor: "#fff",
        border: `1px solid ${theme.palette.primary.main}`,
        left: "50%",
        marginLeft: "-0.5rem",
        width: "1rem",
        height: "1rem",
        transform: "rotate(45deg)",
        zIndex: 1
    },
    content: {
        position: "relative",
        zIndex: 1,
        backgroundColor: "#fff",
        padding: theme.spacing(2),
        textAlign: "left"
    },
    actionArea: {
        marginTop: theme.spacing(1)
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(0.5),
        top: theme.spacing(0.5),
        backgroundColor: "#fff",
        zIndex: 9
    }
}));

const InfoWindow = (props) => {
    const { info, showInfo, showDetailButtonProps, infoAccessorList = [], onClickAway } = props
    const {buttonLabel, ...otherDetails} = showDetailButtonProps || {}
    const classes = useStyles();
    return (
        <Fade in={showInfo} mountOnEnter unmountOnExit timeout={{ enter: 500 }}>
                <div
                    className={classes.paper}
                onClick={e => e.stopPropagation()}
                >
                    <div className={classes.container}>
                        <div className={classes.caret}></div>
                        <div className={classes.content}>
                            <IconButton className = {classes.closeButton} size="small" onClick={onClickAway}><Close/></IconButton>
                            <Grid container spacing={0.5} justify="space-between">
                                {
                                    infoAccessorList.map((item, index) => {
                                        const { label, accessor, isTitle = false, color,fullWidth, unit } = item
                                        
                                        if (!info[accessor]) {
                                            return null
                                        }
                                        return <Grid item key={index} xs={isTitle || fullWidth ? 12 : "auto"}>
                                            <Typography variant={isTitle ? 'subtitle2' : 'body2'} color = {color} gutterBottom>
                                               {label && <b>{label}: &nbsp;</b>}
                                                <span>{info[accessor]} {unit ? unit : ""}</span>
                                            </Typography>
                                        </Grid>
                                    })
                                }
                            </Grid>
                            <Grid container spacing={2} justify="flex-end" className={classes.actionArea}>
                                <Grid item>
                                    <Button {...otherDetails} variant="outlined" color="primary" size="small" square >{buttonLabel}</Button>
                                </Grid>
                            </Grid>
                        </div>
                    </div>

                </div>
        </Fade>

    );
}

export default InfoWindow;